import React, { useState } from 'react';
import CCEvents, { EventNames } from '@companycam/companycam-events';
import { v1URLsFromAsset } from 'helpers/asset-utils';
import { userHasPermission, SHARE_PHOTOS } from '../../../helpers/permissions';
import SingleShareModal from 'components/photos/SingleShareModal';
import { useCurrentUser } from '../../../hooks';
import GalleryModal from 'components/galleries/GalleryModal';

const NO_ACTION = null;
const NO_MODAL = () => {};
const EMPTY_RESULT = [NO_ACTION, NO_MODAL];

export default function useMenuActionShareSingle({ assets }) {
  const [modalVisible, setModalVisible] = useState(false);
  const user = useCurrentUser();
  const hasPermission = userHasPermission(user, SHARE_PHOTOS);

  const validSelection = assets.length === 1;

  if (!hasPermission || !validSelection) {
    return EMPTY_RESULT;
  }

  const action = () => {
    CCEvents.logEvent(EventNames.SHARE_PHOTO);
    setModalVisible(true);
  };

  const databaseIdFrom = (obj) => parseInt(obj.databaseId, 10);

  const renderModal = () => {
    if (!modalVisible) {
      return null;
    }

    const asset = assets[0];
    if (!asset) {
      return null;
    }
    return asset.__typename === 'Video' ? (
      <GalleryModal
        onRequestClose={() => {
          setModalVisible(false);
        }}
        photoDatabaseIds={null}
        videoDatabaseIds={[databaseIdFrom(asset)]}
      />
    ) : (
      <SingleShareModal
        isOpen={modalVisible}
        onRequestClose={(e) => {
          e.stopPropagation();
          setModalVisible(false);
        }}
        photo={v1URLsFromAsset(asset)}
      />
    );
  };

  return [action, renderModal];
}
